
export function normalizeString(value: string): string {
  return value
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

export function formatearFecha(fechaIso: string): string {
  if (!fechaIso) return '—';

  const fecha = new Date(fechaIso);
  if (isNaN(fecha.getTime())) return 'Fecha inválida';

  const dia = fecha.getDate();
  const mes = fecha.getMonth();
  const anio = fecha.getFullYear();

  const meses = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];

  return `${dia} ${meses[mes]} ${anio}`;
}

export function cleanPhoneNumber(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  return digits.startsWith('52') ? digits.slice(2) : digits;
}
